<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="搜索内容：" label-for="key">
              <Input search enter-button placeholder="请输入出栏批次/耳标编号搜索" clearable v-model="filter.search"
                     @on-search="search" @on-clear="searchClear">
              </Input>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="所属基地："  label-for="key">
              <Select v-model="filter.land_base_id" class="perW100" @on-change="selectLandBase">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in landBaseList" :value="key" :key="key">{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="猪只类别："  label-for="key">
              <Select v-model="filter.pig_type_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in pigTypeList" :value="key" :key="key">{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="猪只品种："  label-for="key">
              <Select v-model="filter.pig_variety_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in pigVarietyList" :value="key" :key="key">{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="筛选圈舍：">
              <Select v-model="filter.pig_house_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in pigHouseList" :key="key" :value="key" >{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="创建时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段" style="width: 100%" @on-ok="dateOk" @on-change="dateChange" @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </Form>

      <Table :columns="columns" stripe  :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="action">
          <a @click="download(row)" :disabled="row.type !== 1">溯源二维码</a>
          <Divider type="vertical"/>
          <a @click="changeShowSource(row.pig_out_id, row.show_source ? '关闭溯源' : '开启溯源')">{{row.show_source ? '关闭溯源' : '开启溯源'}}</a>
        </template>

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page" show-total  @on-change="changePage"></Page>
    </Card>

    <Modal
      v-model="qrCodeShow"
      title="溯源二维码">
      <div style="width: 100%;height: 100%;display: flex;justify-content: center;">
        <img :src="qrCodeUrl" alt="溯源二维码">
      </div>
      <div slot="footer">
        <Button type="primary" @click="qrCodeOk">下载</Button>
        <Button @click="qrCodeCancel">关闭</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import {pigOutChangeShowSourceApi, pigOutListApi, pigOutTraceabilityCodeApi} from '@/api/pigFarm/pigOut'
import { pigTypeAllApi } from '@/api/pigFarm/pigType'
import { pigVarietyAllApi } from '@/api/pigFarm/pigVariety'
import {pigHouseAllApi} from "@/api/pigFarm/pigHouse";
import {landBaseAllApi} from "@/api/landBase/landBase";

export default {
  name: 'traceabilityCodePigList',
  inject: ['reload'],
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        ctime: [],
        export: 0,
        type: 1,
        search: "",
        land_base_id: 0,
        pig_house_id: 0,
        pig_type_id: 0,
        pig_variety_id: 0,
      },
      qrCodeShow: false,
      tagSn: '',
      qrCodeUrl: '',
      landBaseList: [],
      pigHouseList: [],
      pigTypeList: [],
      pigVarietyList: [],
      tableData: [],
      tableCount: 0,
      loading: false,
      exportLoading: false,
      columns: [
        {
          title: '出栏批次',
          key: 'pig_out_sn',
          minWidth: 200
        },
        {
          title: '溯源状态',
          key: 'show_source_msg',
          minWidth: 120
        },
        {
          title: '所属基地',
          key: 'land_base_name',
          minWidth: 180
        },
        {
          title: '猪只类别',
          key: 'pig_type_name',
          minWidth: 100
        },
        {
          title: '猪只品种',
          key: 'pig_variety_name',
          minWidth: 100
        },
        {
          title: '所属圈舍',
          key: 'pig_house_name',
          minWidth: 100
        },
        {
          title: '耳标编号',
          key: 'tag_sn',
          minWidth: 180
        },
        {
          title: '重量(kg)',
          key: 'weight',
          minWidth: 120
        },
        {
          title: '销售单价(元/kg)',
          key: 'sale_price',
          minWidth: 130
        },
        {
          title: '销售总价(元)',
          key: 'total_price',
          minWidth: 130
        },
        {
          title: '出栏类型',
          key: 'type_msg',
          minWidth: 100
        },
        {
          title: '流向',
          key: 'to_things',
          minWidth: 150
        },
        {
          title: '出栏时间',
          key: 'date',
          minWidth: 130
        },
        {
          title: '操作人',
          key: 'operator',
          minWidth: 100
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 180
        }

      ]
    }
  },
  created () {
    this.loadTableData()
    this.loadLandBaseData()
    this.loadPigTypeData()
    this.loadPigHouseData()
    this.loadPigVarietyData()
  },
  methods: {
    loadTableData () {
      this.loading = true
      this.filter.export = 0
      pigOutListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 猪类别
    loadPigTypeData() {
      pigTypeAllApi({land_base_id: this.filter.land_base_id}).then(res => {
        if (res.code === 200) {
          this.pigTypeList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 猪品种
    loadPigVarietyData() {
      pigVarietyAllApi({land_base_id: this.filter.land_base_id}).then(res => {
        if (res.code === 200) {
          this.pigVarietyList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage (status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search () {
      this.filter.page = 1
      this.loadTableData()
    },
    // 搜索清空
    searchClear () {
        this.filter.search = ''
        this.loadTableData()
    },
    // 下拉选择
    select(value){
      this.loadTableData()
    },
    // 选择时间
    dateOk(){
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr){
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear(){
      this.filter.ctime = []
      this.loadTableData()
    },

    // 加载圈舍数据
    loadPigHouseData() {
      pigHouseAllApi({land_base_id: this.filter.land_base_id}).then(res => {
        if (res.code === 200) {
          this.pigHouseList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error()
      })
    },

    // 获取基地
    loadLandBaseData() {
      landBaseAllApi({type: 3}).then(res => {
        if (res.code === 200) {
          this.landBaseList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 选择基地
    selectLandBase(){
      this.filter.pig_type_id = 0
      this.filter.pig_variety_id = 0
      this.filter.pig_house_id = 0
      this.loadPigTypeData()
      this.loadPigVarietyData()
      this.loadPigHouseData()
      this.loadTableData()
    },

    // 下载溯源二维码
    download(row) {
      this.tagSn = row.tag_sn
      pigOutTraceabilityCodeApi(row.pig_out_id).then(response => {
        const blob = response.data;
        this.qrCodeUrl = ''
        if (blob && blob instanceof Blob) {
          this.qrCodeUrl = window.URL.createObjectURL(blob);
          this.qrCodeShow = true;
        } else {
          console.error('响应数据不是有效的 Blob 对象:', blob);
        }
      }).catch(error => {
        console.error('下载二维码失败', error);
        if (error.response) {
          console.error('响应错误:', error.response.data);
          console.error('响应状态码:', error.response.status);
          console.error('响应头:', error.response.headers);
        } else if (error.request) {
          console.error('请求错误:', error.request);
        } else {
          console.error('其他错误:', error.message);
        }
      });
    },
    qrCodeCancel(){
      this.qrCodeShow = false
      setTimeout(() => {
        this.qrCodeUrl = ''
        this.tagSn = ''
        window.URL.revokeObjectURL(this.qrCodeUrl);
      }, 500);
    },
    qrCodeOk(){
      // 创建一个下载链接并触发下载
      const link = document.createElement('a');
      link.href = this.qrCodeUrl;
      link.download = `溯源二维码${this.tagSn}.png`; // 文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.qrCodeShow = false
      setTimeout(() => {
        this.qrCodeUrl = ''
        this.tagSn = ''
        window.URL.revokeObjectURL(this.qrCodeUrl);
      }, 500);
    },

    // 切换溯源状态
    changeShowSource(id, msg){
      this.$Modal.confirm({
        title: '请注意!',
        content: '<p>确认'+msg+'？</p>',
        onOk: () => {
          // 修改
          pigOutChangeShowSourceApi(id).then(async res => {
            this.$Message.success(res.msg)
            this.loadTableData()
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        },
        onCancel: () => {
          this.loadTableData()
        }
      })

    },

  }
}
</script>
